import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../utils/response';
import { errorResponse } from '../../utils/response';
import { GetLanguage } from '../../utils/language';
import * as parameter from '../../utils/parameter';
import * as storage from '../../utils/storage';
import { getDeviceInfo } from '@utils/deviceInfo';

export async function generateCode(userCode, email, conn) {
    const devInfo = await encodeURIComponent(JSON.stringify(await getDeviceInfo()));

    const param = JSON.stringify({
        userCode: userCode,
        email: email,
        language: GetLanguage(),
        conn: conn == null ? storage.getConnectionString().value : conn,
        isPrefixDB: conn != null,
        deviceInfo: devInfo
    });

    return fetch('password/generateCode', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: param
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function reset(userCode, email, confirmationCode, password, passwordAzur, key, conn) {
    return fetch('password/reset', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: userCode,
            email: email,
            confirmationCode: confirmationCode,
            password: password,
            passwordAzur: passwordAzur,
            clientKey: key,
            keyPassword: parameter.encryptKeyPassword,
            conn: conn == null ? storage.getConnectionString().value : conn,
            isPrefixDB: conn != null
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function firstSetup(userCode, birthDate, password, passwordAzur, key, conn) {
    return fetch('password/firstSetup', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: userCode,
            birthDate: birthDate,
            password: password,
            passwordAzur: passwordAzur,
            clientKey: key,
            conn: conn == null ? storage.getConnectionString().value : conn,
            isPrefixDB: conn != null
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function updatePassword(userCode, oldPassword, password, passwordAzur, conn) {
    return fetch('password/updatePassword', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: userCode,
            oldPassword: oldPassword,
            password: password,
            passwordAzur: passwordAzur,
            conn: conn == null ? storage.getConnectionString().value : conn,
            isPrefixDB: conn != null
        })
    })
    .then(checkHttpStatus)
    .then(expiredToken)
    .then(parseJSON)
    .then(response => {
        try {
            return JSON.parse(response.result);
        } catch (e) {
            errorResponse(response);
        }
    })
    .catch(error => {
        errorResponse(error);
    })
}

export async function sendForgotUserNameEmail(email, company) {
    const devInfo = await encodeURIComponent(JSON.stringify(await getDeviceInfo()));

    return fetch('password/sendForgotUserNameEmail', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: email,
            company: company,
            language: GetLanguage(),
            deviceInfo: devInfo,
            conn: storage.getConnectionString().value
        })
    })
    .then(checkHttpStatus)
    .then(expiredToken)
    .then(parseJSON)
    .then(response => {
        try {
            return JSON.parse(response.result);
        } catch (e) {
            errorResponse(response);
        }
    })
    .catch(error => {
        errorResponse(error);
    })
}